
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"24","viewBox":"0 0 18 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","d":"M8.873.105C4.174.105.403 3.99.403 8.769c0 5.925 6.051 15.126 8.47 15.126 2.079 0 8.408-9.201 8.408-15.126 0-4.778-3.771-8.664-8.408-8.664z"}}),_c('path',{attrs:{"fill":"#562882","d":"M8.873.105C4.174.105.403 3.99.403 8.769c0 5.925 6.051 15.126 8.47 15.126 2.079 0 8.408-9.201 8.408-15.126 0-4.778-3.771-8.664-8.408-8.664zm0 3.504c-2.782 0-5.008 2.357-5.008 5.16 0 2.867 2.226 5.16 5.008 5.16 2.72 0 5.008-2.293 5.008-5.16 0-2.803-2.288-5.16-5.008-5.16z"}}),_c('circle',{attrs:{"cx":"8.842","cy":"8.732","r":"2.742","fill":"#562882","fill-rule":"nonzero"}})])])
          )
        }
      }
    